import React from 'react';
import { Box, Typography } from '@mui/material';

const ChangeOrders: React.FC = () => {
  return (
    <Box p={3}>
      <Typography variant="h2">Change Orders</Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Placeholder page for listing and managing change orders.
      </Typography>
    </Box>
  );
};

export default ChangeOrders;